import { useId } from "react";
import { Checkbox } from "@/shared/components/ui/checkbox";
import {
  Field,
  FieldContent,
  FieldDescription,
  FieldLabel,
} from "@/shared/components/ui/field";
import { FieldErrors, FieldProps } from "@/shared/components/field/field";

/**
 * A labelled checkbox with the description and error slots of the `/field`
 * components. It reports every change immediately, there is nothing to
 * debounce.
 */
export function CheckboxField({
  label,
  description,
  errors,
  fieldProps,
  checked,
  onCheckedChange,
  disabled,
}: {
  checked: boolean;
  onCheckedChange: (checked: boolean) => void;
  disabled?: boolean;
} & FieldProps) {
  const id = useId();

  return (
    <Field orientation="horizontal" {...fieldProps}>
      <Checkbox
        id={id}
        checked={checked}
        onCheckedChange={(state) => onCheckedChange(state === true)}
        disabled={disabled}
        aria-invalid={errors && errors.length > 0}
      />
      <FieldContent>
        {label && <FieldLabel htmlFor={id}>{label}</FieldLabel>}
        {description && <FieldDescription>{description}</FieldDescription>}
        <FieldErrors errors={errors} />
      </FieldContent>
    </Field>
  );
}
